import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetVehicles = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/vehicles`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        institutionId: institutionId,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    return error;
  }
};

export const APICreateVehicle = async (
  vehicleData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...vehicleData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/vehicles`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating vehicle:", error);
    return error;
  }
};

export const APIUpdateVehicle = async (
  vehicleData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  const formattedData = {
    ...vehicleData,
    institutionId: institutionId,
  };

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/vehicles/`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating vehicle:", error);
    return error;
  }
};

export const APIDeleteVehicles = async (
  vehicleNumber,
  setLoading,
  institutionId,
  token,
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  const formattedData = {
    vehicleNumber: vehicleNumber,
    institutionId: institutionId,
  };

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/vehicles`, {
        headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: formattedData,
    });
    return result;
  } catch (error) {
    console.error("Error deleting vehicle:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APICheckVehicleTelematics = async (
  vehicleNumber,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const encodedVehicleNumber = encodeURIComponent(vehicleNumber?.trim?.() || "");
    const result = await axios.get(
      `${apiConfig.baseURL}/vehicles/telematic-check/${encodedVehicleNumber}`,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error checking vehicle telematics:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
